import React from "react";

const Initiative = () => {
  return (
    <div class="flex flex-col items-center gap-5 py-16 text-center bg-[#F9FAFB]">
      <div className="text-5xl text-black">
        This Initiative Piloted In Turkana, West Pokot and Wajir By
      </div>
      <div className="px-[125px] text-[20px] text-black">
        Turkana County Government, Turkana County Assembly, National Drought
        Management Authority, Kenya National Commission on Human Rights (KNCHR),
        African Development Solutions (ADESO), Help Age international, Diocese
        of Lodwar, International Rescue Committee (IRC), LOKADO, Lutheran World
        Relief services, Save the Children, TUDOF, TWADO, Oxfam, World Vision
        Kenya and VSF Germany, West Pokot County Government, County Commissioner
        Office, NDMA, KNCHR, Yangat- Girl Child Potential Sensitization Group,
        Sikom, FEP Group, POKATUSA, LIDS NGO, World Vision Kenya, Kalya-Peace,
        Action Aid, ACTED, Pokot ICC, West Pokot Council of Elders, CHEKODIP,
        Action Against Hunger USA (ACF) and Tegla Loroupe Peace Foundation,
        Wajir County Government, Wajir County Assembly, County Commissioner
        Office, NDMA, KNHRC, National Environmental Management Authority, Oxfam,
        Kenya red cross, District Pastoralists Association of Wajir, Save the
        children, ALDEF, Adeso, Mercy Corps, WAPNET, Islamic Relief, Wajir South
        Development Agency and APHIA Plus IMARISHA.
      </div>
    </div>
  );
};

export default Initiative;
